import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BnNgIdleService } from 'bn-ng-idle'; // import bn-ng-idle service
import { CanDeactivateGuard } from './services/auth-guard.service';
import { ExcelService } from './services/excel.service';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { HttpErrorInterceptor } from './interceptors/error-interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatTabsModule} from '@angular/material/tabs';

//pipes
import { FormatAmountPipe } from './pipes/format-amount.pipe';
import { RemoveCommaPipe } from './pipes/pipe-number';
import { changestatusPipe } from './pipes/pipe-status';
import { TruncatecardPipe } from './pipes/pipe-carte';
import { changebanquePipe } from './pipes/pipe-banque';
import { CustomDatePipe} from './_helpers/custom.datepipe'

//directiuves
import { UserDisplayDirective } from './directive/porteur-display';
//Angular material
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatBadgeModule } from '@angular/material/badge';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    CustomDatePipe,
    RemoveCommaPipe,
    changestatusPipe,
    TruncatecardPipe,
    changebanquePipe,
    FormatAmountPipe,
    UserDisplayDirective,

  ],
  imports: [
    CommonModule,
    HttpClientModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatDividerModule,
    MatCardModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatBadgeModule,
    MatExpansionModule,MatSnackBarModule,
    MatSlideToggleModule,MatCheckboxModule,MatDatepickerModule,MatFormFieldModule,MatNativeDateModule,MatGridListModule,MatSidenavModule,MatListModule,MatPaginatorModule,
  ],
  exports: [
    // Export the components, directives, and pipes to be reused in other modules
    CustomDatePipe,
    RemoveCommaPipe,
    changestatusPipe,
    TruncatecardPipe,
    changebanquePipe,
    FormatAmountPipe,
    UserDisplayDirective,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatPaginatorModule,
    CommonModule // Export CommonModule to make *ngIf, *ngFor, etc. available
  ],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},{
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true
  },ExcelService,CanDeactivateGuard,RemoveCommaPipe,TruncatecardPipe,changestatusPipe,changebanquePipe,BnNgIdleService],
})
export class SharedModule { }

